export enum SyncState {
  upToDate = 'upToDate',
  moreThan24HoursOld = 'moreThan24HoursOld',
}
